import { render, staticRenderFns } from "./ProductSharesEditor.vue?vue&type=template&id=1193e077&scoped=true&lang=html&"
import script from "./ProductSharesEditor.vue?vue&type=script&lang=js&"
export * from "./ProductSharesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductSharesEditor.vue?vue&type=style&index=0&id=1193e077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193e077",
  null
  
)

export default component.exports